export default class PartnerModel {
    Id ? : string;
    Name ? : string;
    CreatedDate ? : String;
    Status ? : string;

    constructor(id: string, name: string, createdate: string , status : string) {
        this.Id = id;
        this.Name = name;
        this.CreatedDate = createdate;
        this.Status=status;
      }
}
